module.exports = __webpack_public_path__ + "img/box2_tag1.bb23739f.png";